export class Password {
  senhaAntiga: string;
  senhaNova: string;
  confirmarSenha: string;
}
